var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 9.2C0.399902 4.3 4.3999 0.400002 9.1999 0.400002C13.9999 0.400002 17.9999 4.4 17.9999 9.2C17.9999 12.8 16.7999 13.8 10.0999 23.5C9.6999 24.1 8.6999 24.1 8.2999 23.5C1.5999 13.8 0.399902 12.8 0.399902 9.2ZM12.8999 9.2C12.8999 7.2 11.2999 5.5 9.1999 5.5C7.0999 5.5 5.4999 7.2 5.4999 9.2C5.4999 11.2 7.0999 12.9 9.1999 12.9C11.2999 12.9 12.8999 11.2 12.8999 9.2Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4,
    height: 24.3,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbi);
export default __webpack_public_path__ + "static/media/ubi.e20ebbabfbd087ead4af9e4dbb95cefe.svg";
export { ForwardRef as ReactComponent };